import * as i0 from '@angular/core';
import { Pipe, Injectable, Inject, InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/router';
import { DefaultUrlSerializer, UrlSerializer } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';
import * as i1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i2 from '@ngrx/store';
import { createAction, props, createReducer, on, StoreModule, createFeatureSelector, createSelector, select } from '@ngrx/store';
import { tap, map, catchError } from 'rxjs/operators';
import { switchMap, of, throwError } from 'rxjs';
import * as i1$1 from '@angular/common/http';
import { HttpParams, HttpHeaders } from '@angular/common/http';

class DrupalToAngularRoutePipe {
    transform(value) {
        return undefined;
    }
}
DrupalToAngularRoutePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalToAngularRoutePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DrupalToAngularRoutePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DrupalToAngularRoutePipe, name: "drupalToAngularRoute" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalToAngularRoutePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'drupalToAngularRoute'
                }]
        }] });

class UrlsCacheService {
    constructor(drupalToAngularRoutePipe) {
        this.drupalToAngularRoutePipe = drupalToAngularRoutePipe;
        this.angularRoutesToContentPaths = new Map();
        this.contentPathsToAngularRoutes = new Map();
    }
    hasContentPath(contentPath) {
        return this.contentPathsToAngularRoutes.has(contentPath);
    }
    getContentUrl(angularPath) {
        return this.angularRoutesToContentPaths.get(angularPath);
    }
    getAngularUrl(contentPath) {
        return this.contentPathsToAngularRoutes.get(contentPath);
    }
    addPathsInfos(resources) {
        if (Array.isArray(resources)) {
            resources.forEach((item) => {
                const angularPath = this.drupalToAngularRoutePipe.transform(item);
                const contentPath = item.path;
                if (angularPath && contentPath) {
                    this.angularRoutesToContentPaths.set(angularPath, contentPath);
                    this.contentPathsToAngularRoutes.set(contentPath, angularPath);
                }
            });
        }
    }
}
UrlsCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UrlsCacheService, deps: [{ token: DrupalToAngularRoutePipe }], target: i0.ɵɵFactoryTarget.Injectable });
UrlsCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UrlsCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UrlsCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: DrupalToAngularRoutePipe }]; } });

class DrupalUrlSerializerService extends DefaultUrlSerializer {
    constructor(urlsService, window) {
        super();
        this.urlsService = urlsService;
        this.window = window;
    }
    _beautifyUrl(url, tree) {
        const beautifyUrl = this.urlsService.getContentUrl(url) ?? url;
        return beautifyUrl;
    }
    _reverseUrl(url) {
        const reverseUrl = this.urlsService.getAngularUrl(url) ?? url;
        return reverseUrl;
    }
    parse(url) {
        return super.parse(this._reverseUrl(url));
    }
    serialize(tree) {
        return this._beautifyUrl(super.serialize(tree), tree);
    }
}
DrupalUrlSerializerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalUrlSerializerService, deps: [{ token: UrlsCacheService }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable });
DrupalUrlSerializerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalUrlSerializerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalUrlSerializerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: UrlsCacheService }, { type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; } });

const setPathInfos = createAction('[DrupalPaths] Set PathInfos', props());

class DrupalPathsEffects {
    constructor(actions$, urlsCacheService) {
        this.actions$ = actions$;
        this.urlsCacheService = urlsCacheService;
        this.setPathInfos$ = createEffect(() => {
            return this.actions$.pipe(ofType(setPathInfos), tap(action => {
                if (action.pathInfos) {
                    this.urlsCacheService.addPathsInfos(action.pathInfos);
                }
            }));
        }, { dispatch: false });
    }
}
DrupalPathsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalPathsEffects, deps: [{ token: i1.Actions }, { token: UrlsCacheService }], target: i0.ɵɵFactoryTarget.Injectable });
DrupalPathsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalPathsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalPathsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Actions }, { type: UrlsCacheService }]; } });

const drupalPathFeatureKey = 'drupalPath';
const initialState = {
    infos: {}
};
const reducer = createReducer(initialState, on(setPathInfos, (state, action) => {
    const newPathInfos = {};
    const pathInfos = action.pathInfos;
    if (Array.isArray(pathInfos)) {
        pathInfos.forEach(pathInfo => {
            newPathInfos[pathInfo.path] = {
                ...state.infos?.[pathInfo.path],
                ...pathInfo
            };
        });
    }
    return {
        ...state,
        infos: {
            ...state.infos,
            ...newPathInfos
        }
    };
}));

const DRUPAL_PATHS_CONFIG = new InjectionToken('DRUPAL_PATHS_CONFIG');

class NgrxDrupalPathsToRoutesModule {
    static forRoot(languages, pathApi, drupalToAngularRoutePipeClass, addTrailingSlash = false) {
        return {
            ngModule: NgrxDrupalPathsToRoutesModule,
            providers: [
                { provide: UrlSerializer, useClass: DrupalUrlSerializerService },
                {
                    provide: DrupalToAngularRoutePipe,
                    useClass: drupalToAngularRoutePipeClass
                },
                {
                    provide: DRUPAL_PATHS_CONFIG,
                    useFactory: () => {
                        return {
                            languages,
                            pathApi,
                            addTrailingSlash
                        };
                    }
                }
            ]
        };
    }
}
NgrxDrupalPathsToRoutesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: NgrxDrupalPathsToRoutesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgrxDrupalPathsToRoutesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: NgrxDrupalPathsToRoutesModule, imports: [CommonModule, i1.EffectsFeatureModule, i2.StoreFeatureModule] });
NgrxDrupalPathsToRoutesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: NgrxDrupalPathsToRoutesModule, imports: [CommonModule,
        EffectsModule.forFeature([DrupalPathsEffects]),
        StoreModule.forFeature(drupalPathFeatureKey, reducer)] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: NgrxDrupalPathsToRoutesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        EffectsModule.forFeature([DrupalPathsEffects]),
                        StoreModule.forFeature(drupalPathFeatureKey, reducer)
                    ]
                }]
        }] });

const selectDrupalPathsState = createFeatureSelector(drupalPathFeatureKey);
const selectPathInfosEntities = createSelector(selectDrupalPathsState, (state) => {
    return state?.infos;
});
//TODO remove
const selectPathInfos = (id) => createSelector(selectDrupalPathsState, (state) => {
    return state?.infos[id] ?? null;
});
const selectPathInfosByPath = (path) => createSelector(selectDrupalPathsState, (state) => {
    return state?.infos?.[path] ?? null;
});

class PathService {
    constructor(httpClient, config, store) {
        this.httpClient = httpClient;
        this.config = config;
        this.store = store;
    }
    getPathInfos(path) {
        const finalPath = `/${path}${this.config.addTrailingSlash ? '/' : ''}`;
        const pathInfos$ = this.store.pipe(select(selectPathInfosByPath(finalPath)));
        return pathInfos$.pipe(switchMap(pathInfos => {
            if (pathInfos) {
                return of(pathInfos);
            }
            return this.loadPathInfos(path);
        }));
    }
    loadPathInfos(path) {
        const drupalPath = path === '' ? '/' : path;
        return this.httpClient
            .get(this.config.pathApi, {
            params: new HttpParams().set('path', drupalPath),
            headers: new HttpHeaders({ Accept: 'application/json' })
        })
            .pipe(map((result) => {
            const { isHomePath, label, entity: { canonical, uuid }, meta, jsonapi: { resourceName } } = result;
            const apiEntryPointUrl = new URL(result.jsonapi.entryPoint);
            const pathName = apiEntryPointUrl.pathname;
            const pathNameSplit = pathName.split('/');
            const language = pathNameSplit?.[1];
            const pathInfos = {
                id: uuid,
                type: resourceName,
                language,
                frontPage: isHomePath,
                path: `${new URL(canonical).pathname}${this.config.addTrailingSlash ? '/' : ''}`,
                canonicalUrl: `${canonical}${this.config.addTrailingSlash ? '/' : ''}`,
                description: '',
                title: label,
                meta
            };
            return pathInfos;
        }), catchError((error) => {
            return throwError(() => error);
        }));
    }
}
PathService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PathService, deps: [{ token: i1$1.HttpClient }, { token: DRUPAL_PATHS_CONFIG }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Injectable });
PathService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PathService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PathService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DRUPAL_PATHS_CONFIG]
                }] }, { type: i2.Store }]; } });

class DrupalUrlGuard {
    constructor(drupalPathsConfig, drupalToAngularRoutePipe, pathService, urlsCacheService, router) {
        this.drupalPathsConfig = drupalPathsConfig;
        this.drupalToAngularRoutePipe = drupalToAngularRoutePipe;
        this.pathService = pathService;
        this.urlsCacheService = urlsCacheService;
        this.router = router;
    }
    canActivate(route, state) {
        const { url } = state;
        const addTrailingSlash = this.drupalPathsConfig?.addTrailingSlash || false;
        const urlSegments = url.split('/').filter((segment) => !!segment);
        const hasAlreadyEndSlash = url.charAt(url.length - 1) === '/';
        const drupalUrl = urlSegments.join('/');
        const finalUrl = `${url}${addTrailingSlash && !hasAlreadyEndSlash ? '/' : ''}`;
        if (this.urlsCacheService.hasContentPath(finalUrl)) {
            return this.router.parseUrl(finalUrl);
        }
        const pathInfos$ = this.pathService.getPathInfos(drupalUrl);
        return pathInfos$.pipe(map((pathInfos) => {
            this.urlsCacheService.addPathsInfos([pathInfos]);
            let angularUrl;
            if (this.drupalToAngularRoutePipe) {
                angularUrl = this.drupalToAngularRoutePipe.transform(pathInfos);
            }
            if (angularUrl) {
                return this.router.parseUrl(angularUrl);
            }
            return true;
        }), catchError((error) => {
            console.error('error while retrieving path infos', { error });
            return of(true);
        }));
    }
}
DrupalUrlGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalUrlGuard, deps: [{ token: DRUPAL_PATHS_CONFIG }, { token: DrupalToAngularRoutePipe }, { token: PathService }, { token: UrlsCacheService }, { token: i4.Router }], target: i0.ɵɵFactoryTarget.Injectable });
DrupalUrlGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalUrlGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DrupalUrlGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DRUPAL_PATHS_CONFIG]
                }] }, { type: DrupalToAngularRoutePipe }, { type: PathService }, { type: UrlsCacheService }, { type: i4.Router }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { DRUPAL_PATHS_CONFIG, DrupalToAngularRoutePipe, DrupalUrlGuard, NgrxDrupalPathsToRoutesModule, PathService, selectDrupalPathsState, selectPathInfos, selectPathInfosByPath, selectPathInfosEntities, setPathInfos };
